import styled from 'styled-components';
import { color } from 'theme/Color';

interface DTCOverviewContainerProps {
  mode: string;
}

export const DTCOverviewContainer = styled.div<DTCOverviewContainerProps>`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 18px;
  color: ${({ mode }) =>
    mode === 'light' ? `${color._616161}` : `${color._efefef}`};

  & .header {
    font-family: 'Inter';
    color: ${({ mode }) => (mode === 'light' ? color._616161 : color._efefef)};
    font-weight: 700;
    font-size: 18px;
    width: 100%;
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  & .card-panel {
    background: ${({ mode }) =>
      mode === 'light'
        ? `${color._FBFCFE} !important`
        : `${color._1d1d1d} !important`};
    border: ${({ mode }) =>
      mode === 'light' ? `1px solid ${color._D7E5F8}` : ' '};
    border-radius: 8px;
    padding: 18px;
    margin-top: 20px;
  }

  & .noBorder {
    border: none !important;
  }
`;
